const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const URLMake = require("../../../shared/URLMake");
const OpsUser = require("../../core/vault/OpsUser");
const AT = require("../../core/vault/ActionTypes");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Link = require("../../core/view/Link");
const Cart = require("./Cart");

const OrderSummary = require("./OrderSummary");
const ShippingMethod = require("./ShippingMethod");
const OpsCart = require("../vault/OpsCart");

const styles = require("./styles/ReviewCart.css");
const {BundleConversionModal} = require("./BundleConversionModal");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReviewClassWalletCart",

		propTypes: {
			user: PT.object.isRequired,
			cart: PT.object.isRequired,
			onContinue: PT.func,
			step: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			checkoutLockedForLoggedIn: function() {
				this.showSubsWarning();
			},
			bundleConverted: function(newCart) {
				if (!OpsCart.canConvertBundle(newCart.items)) {
					this.setState({showBundleModal: false});
				}
			},
		},

		getInitialState: function() {
			return {
				cartHadItems: !OpsCart.isEmpty(this.props.cart),
				showBundleModal: false,
			};
		},

		componentDidMount: function() {
			// Need to get and populate customer info
			this.props.dispatch({
				type: AT.CLASS_WALLET_GET_CUSTOMER_INFO_REQUEST,
			});
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			if (!this.state.cartHadItems && !OpsCart.isEmpty(nextProps.cart)) {
				this.setState({cartHadItems: true});
			}
		},

		canBuySubscriptions: function(user) {
			// A user can buy a subscription if they are neither in the ClassWallet flow
			// nor logged in
			return (
				!OpsCart.isClassWalletFlow(this.props.cart) && !OpsUser.isLoggedIn(user)
			);
		},

		showSubsWarning: function() {
			const {user, cart} = this.props;
			const isParent = OpsUser.hasParentRole(user);
			const itemsWithBundles = OpsCart.getItemsWithBundles(cart.items);
			this.props.dispatch({
				type: AT.SHOW_OFFICE_MESSAGE,
				messageType: "subsThruAccount",
				extraInfo: {
					role: isParent ? "parent" : "other",
					hasBooks: OpsCart.hasBookItems(itemsWithBundles),
				},
			});
		},

		onContinue: function() {
			const validation = this.getValidation();
			const showError =
				!_.isEmpty(validation.errorTypes) || !_.isEmpty(validation.items);
			const {cart} = this.props;

			// checks for bundling
			if (OpsCart.canConvertBundle(cart.items)) {
				this.setState({showBundleModal: true});
			}
			if (!showError) {
				this.props.onContinue();
			}
		},

		closeBundleModal: function() {
			this.setState({showBundleModal: false});
		},

		makeBundle: function(selectOptionState) {
			let bundleID = selectOptionState.selected;
			// subscriptionKey will be the name of a named subscription or "beast-bulk-codes"
			const subscriptionKey = selectOptionState.additionalSelected;
			// bundles that contain a different subscription SKU will have the SKU
			// appended to the bundleID
			// e.g. bundle-grade-1 (contains beast-yearly) vs
			// bundle-grade-1-beast-bulk-codes (contains beast-bulk-codes)
			if (subscriptionKey === "beast-bulk-codes") {
				bundleID = `${bundleID}-${subscriptionKey}`;
			}
			this.props.dispatch({
				type: AT.CONVERT_BUNDLE,
				subscriptionKey,
				bundleID,
			});
		},

		getValidation: function() {
			const {cart} = this.props;
			const shippingMethod = _.get(cart, [
				"form",
				"data",
				"shipping",
				"method",
			]);
			const errorTypes = {};
			if (!shippingMethod || shippingMethod.length === 0) {
				errorTypes.method = {
					type: "E_MISSING",
				};
			}
			// Also check if they have any subs in their cart
			if (OpsCart.hasSubscriptionItems(cart.items)) {
				errorTypes.items = {
					type: "E_SUBSCRIPTION_IN_CLASSWALLET_CART",
				};
			}
			return _.extend(
				{},
				{
					errorTypes,
				}
			);
		},

		updateField: function(field, val) {
			this.props.dispatch({
				type: AT.UPDATE_CART_FORMDATA,
				section: "shipping",
				vals: {[field]: val},
			});
		},

		classWalletContinue: function() {
			this.props.dispatch({
				type: AT.CLASS_WALLET_SUBMIT_REQUEST,
			});
		},

		getSubscriptionsErrorType: function(user, cart) {
			let subscriptionsErrorType = null;
			if (!this.canBuySubscriptions(user)) {
				if (OpsCart.isClassWalletFlow(cart)) {
					subscriptionsErrorType = "classwallet";
				} else if (OpsUser.hasParentRole(user)) {
					subscriptionsErrorType = "parent";
				} else {
					subscriptionsErrorType = "other";
				}
			}
			return subscriptionsErrorType;
		},

		render: function() {
			let cartEl;
			const {cart, user, step} = this.props;
			const subscriptionsErrorType = this.getSubscriptionsErrorType(user, cart);
			const validation = this.getValidation();
			if (!this.state.cartHadItems && OpsCart.isEmpty(cart)) {
				cartEl = (
					<div className={styles.empty}>
						<div className={styles.text}>Your cart is currently empty.</div>
						<div className={styles.browseBooks}>
							<Link to={URLMake.forBookCollections()} className={styles.button}>
								Browse Books
							</Link>
						</div>
					</div>
				);
			} else {
				const getPriceForMethod = method => {
					return OpsCart.calculateShippingPriceWithMethod(
						this.props.cart,
						method
					);
				};
				const shippingInfo = _.extend(
					OpsCart.getFormSection(this.props.cart, "shipping"),
					{country: "US"}
				);
				cartEl = (
					<div className={styles.classWalletCart}>
						<Cart
							cart={cart}
							tabIndexStart={1}
							subscriptionsErrorType={subscriptionsErrorType}
							step={step}
						/>
						{OpsCart.needsShipping(this.props.cart) ? (
							<div className={styles.classWalletShippingMethod}>
								<ShippingMethod
									cart={this.props.cart}
									shippingInfo={shippingInfo}
									updateField={this.updateField}
									getPriceForMethod={getPriceForMethod}
									validation={validation}
									initialTabIndex={1}
								/>
							</div>
						) : null}
					</div>
				);
			}
			const showError =
				!_.isEmpty(validation.errorTypes) || !_.isEmpty(validation.items);
			return (
				<div className={styles.main}>
					<div className={styles.content}>
						<div className={styles.title}>{"Cart"}</div>
						<div className={styles.across}>
							<div className={styles.formContainer}>{cartEl}</div>
							<OrderSummary
								cart={cart}
								onContinue={() => this.onContinue()}
								hideFinalButtons={false}
								hidePaypalButton={true}
								hideCouponEntry={true}
								showItemize={true}
								showError={showError}
								tabIndex={500}
								step={step}
							/>
						</div>
					</div>
					{this.state.showBundleModal ? (
						<BundleConversionModal
							cart={cart}
							makeBundle={this.makeBundle}
							onClose={this.closeBundleModal}
							simplified={false}
						/>
					) : null}
				</div>
			);
		},
	})
);
